import { z } from 'zod';

export const schemaConsorsErrorResponse = z
    .object({
        errorCode: z.string().nullish(),
        trackingId: z.string().nullish(),
    })
    .passthrough();

export type SchemaConsorsErrorResponse = z.infer<typeof schemaConsorsErrorResponse>;
